import { atom } from 'recoil';

export const openCarouselState = atom({
  key: 'openCarouselState', 
  default: false,           
});

export const productGuideDataState = atom({
  key: 'productGuideDataState', 
  default: [{image: "",
    "title":'',
    "description":'',
    "video": '',
    "gif": '',
  }],           
});